import { useInfiniteQuery, useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { useTypedOpenApi } from '../../providers';
import { publicChecklistsInfiniteQueryOptions } from './publicChecklistQueries';
import type { PublicChecklistsQueryParams } from './types';

/**
 * The public library as an endless scroll.
 *
 * Written by hand rather than through the generated `tanstack.client.ts`, which offers a
 * `queryOptions` helper but no `infiniteQueryOptions` one.
 */
export const useInfinitePublicChecklistsQuery = (params: PublicChecklistsQueryParams) => {
  const { apiClient } = useTypedOpenApi();

  return useInfiniteQuery(publicChecklistsInfiniteQueryOptions(apiClient, params));
};

/**
 * The same list, suspending.
 *
 * The mobile screen renders inside a `Suspense` boundary and shows the app's loading screen while
 * the first page is in flight; suspending keeps that, where a plain `isLoading` branch would put a
 * second, different spinner in the same place.
 */
export const useSuspenseInfinitePublicChecklistsQuery = (params: PublicChecklistsQueryParams) => {
  const { apiClient } = useTypedOpenApi();

  return useSuspenseInfiniteQuery(publicChecklistsInfiniteQueryOptions(apiClient, params));
};
